import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDEmCursoSerralharia = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras/numTotalEmCursoSerra`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_OBRAS_AHD_EM_CURSO_SERRALHARIA", payload: data.yData[0].total });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDEmCursoSerralharia;